import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../common/Logo';

const Footer = () => {
  const location = useLocation();
const year = new Date().getFullYear();
  const handleNavClick = (e, hash) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = `/#${hash}`;
    } else {
      const element = document.getElementById(hash);
      if (element) {
        const headerHeight = window.innerWidth >= 768 ? 96 : 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        window.history.pushState(null, '', `#${hash}`);
      }
    }
  };

  return (
    <footer className="bg-amber-900 text-amber-100 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="mb-4">
              <Logo size="small" variant="light" />
            </div>
            <p className="text-amber-200 text-sm leading-relaxed">
              <strong>Wovn Rugss</strong> (wovnrugss.com) – woven rugs, wovn rugs, wovnrug, wovnrugs, wovenrugs, wovenruggs. Your destination for luxury handcrafted rugs that transform spaces. Handcrafted rugs made with the finest materials and traditional techniques.
            </p>
          </div>
          <div>
            <h4 className="text-amber-50 font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="hover:text-amber-300 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <a href="#products" onClick={(e) => handleNavClick(e, 'products')} className="hover:text-amber-300 transition-colors cursor-pointer">
                  Products
                </a>
              </li>
              <li>
                <Link to="/hand-tufted-rugs" className="hover:text-amber-300 transition-colors">
                  Hand Tufted Rugs
                </Link>
              </li>
              <li>
                <Link to="/hand-knotted-rugs" className="hover:text-amber-300 transition-colors">
                  Hand Knotted Rugs
                </Link>
              </li>
              <li>
                <a href="#about" onClick={(e) => handleNavClick(e, 'about')} className="hover:text-amber-300 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className="hover:text-amber-300 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="text-center md:text-left">
            <h4 className="text-amber-50 font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-3.5 text-amber-200 text-sm">
              <li className="flex items-start justify-center md:justify-start gap-3">
                <svg className="w-5 h-5 text-amber-300 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div className="flex flex-col gap-2">
                  <a href="mailto:wovnrugss@gmail.com" className="hover:text-amber-300 transition-colors break-words">wovnrugss@gmail.com</a>
                  <a href="mailto:arham@wovnrugss.com" className="hover:text-amber-300 transition-colors break-words">arham@wovnrugss.com</a>
                </div>
              </li>
              <li className="flex items-start justify-center md:justify-start gap-3">
                <svg className="w-5 h-5 text-amber-300 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+919217612400" className="hover:text-amber-300 transition-colors mt-1">+91 9217612400</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-amber-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-amber-200 text-sm text-center md:text-left">&copy; {year} Wovn Rugss (wovnrugss.com). All rights reserved.</p>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, 'contact')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-full font-semibold hover:from-amber-700 hover:to-orange-700 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Contact Us
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

